<template>
  <div class="introduce">
    <p align="center">
      <img class="introduce_img" src="../images/4introduce.png" />
    </p>
  </div>
</template>

<script>
export default {
  name: "4introduce",
};
</script>

<style scoped lang="scss">
@import "../scss/baseMain";
</style>
